<script setup>
import SidebarEntries from "./SidebarEntries.vue";
import sidebar from "./sidebar.js";

const appTitle = "Ticp Email";
const appDescription = "Piattaforma per la gestione delle email di Telecash.it";
</script>

<template>
    <div class="d-flex flex-column min-vh-100">
        <!-- ---------------------------------------------------------------- -->
        <!-- Header -->
        <!-- ---------------------------------------------------------------- -->
        <header class="p-3">
            <div class="row">
                <div class="col">
                    <h1>{{ appTitle }}</h1>
                </div>
            </div>
            <span>{{ appDescription }}</span>
        </header>
        <!-- ---------------------------------------------------------------- -->
        <!-- Body -->
        <!-- ---------------------------------------------------------------- -->
        <main class="flex-grow-1 d-flex flex-row">
            <div class="sidebar p-3">
                <SidebarEntries :entries="sidebar" :level="0"></SidebarEntries>
            </div>
            <div class="flex-grow-1 p-3">
                <!-- {% if pageTitle or pageDescription %}
                <div class="mb-3 text-muted">
                    <h6 class="mb-0">{{ pageTitle if pageTitle else "&nbsp;" | safe }}</h6>
                    <span class="">{{ pageDescription if pageDescription else "&nbsp;" | safe }}</span>
                </div>
                {% endif %} -->
                <div class="container-fluid p-0">
                    <router-view></router-view>
                </div>
            </div>
        </main>
        <!-- ---------------------------------------------------------------- -->
        <!-- Footer -->
        <!-- ---------------------------------------------------------------- -->
        <footer class="p-3">Piattaforma sviluppata e mantenuta da Telecash.it</footer>
    </div>
</template>
